export default {
	install(Vue) {
		const can = function(permission) {
			const userPermissions = JSON.parse(window.localStorage.getItem("user-permissions")) || [];
			const companySettings = JSON.parse(window.localStorage.getItem("company-settings")) || [];
			const permissionSnakeCase = `can_${permission.split("-").join("_")}`; // run-reports == can_run_reports

			const userPermitted = userPermissions.includes(permission);
			const companyPermitted = companySettings[permissionSnakeCase] || false;

			return [userPermitted, companyPermitted].some(p => p == true);
		};

		Vue.directive("can", async function(el, bindings, vnode) {
			if (!can(bindings.arg)) {
				el.style.display = "none";
				vnode.elm.remove(vnode.elm);
			}
		});

		Vue.directive("cannot", async function(el, bindings, vnode) {
			if (can(bindings.arg)) {
				vnode.elm.remove(vnode.elm);
			}
		});

		Vue.mixin({
			methods: {
				can(permission) {
					return can(permission);
				}
			}
		});

		Vue.$can = function(permission) {
			return can(permission);
		};
	}
};
